import type { ModelLead } from '@app/api/Leads/types';

export const mergeLeads = (
  prevLeads: ModelLead[],
  nextLeads: ModelLead[]
): ModelLead[] => {
  const leadById = new Map(prevLeads.map((lead) => [lead.Id, lead]));

  nextLeads.forEach((lead) => {
    leadById.set(lead.Id, lead);
  });

  return Array.from(leadById.values());
};

// SearchLeads is take-based: MaxItems=40 returns items 1-40, including all
// previously loaded leads as fresh server objects. This variant preserves the
// prev reference for any ID already in prevLeads so the WeakMap row cache and
// React.memo on cell components remain effective across load-more appends.
// The realtime patch corrects any lead whose data changed since the last load.
export const referenceStableMergeLeads = (
  prevLeads: ModelLead[],
  nextLeads: ModelLead[]
): ModelLead[] => {
  const prevById = new Map(prevLeads.map((lead) => [lead.Id, lead]));
  return nextLeads.map((lead) => prevById.get(lead.Id) ?? lead);
};
